<div class="error-page-container">
  <mat-card class="error-page-card">
    <div class="error-page-header">
      <mat-card-title class="error-page-title">
        403
      </mat-card-title>
      <mat-card-subtitle class="error-page-subtitle">
        Unauthorized Access
      </mat-card-subtitle>
    </div>

    <mat-card-content>
      You are not authorized to access that page.
    </mat-card-content>

    <mat-card-actions>
      <a routerLink="/dashboard"
         mat-button
         color="primary">Go home</a>
    </mat-card-actions>
  </mat-card>
</div>